import { NgModule } from "@angular/core";
import { Router, RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/auth-guard";
import { Prelaunch } from "src/app/core/models/prelaunch.model";
import { PrelaunchService } from "src/app/core/services/prelaunch.service";
import { MaintenanceModeComponent } from "src/app/login/screens/maintenance-mode/maintenance-mode.component";
import { ConfirmAccountComponent } from "src/app/register/screens/confirm-account/confirm-account.component";
import { RegisterConfirmationComponent } from "src/app/register/screens/register-confirmation/register-confirmation.component";
import { RegisterPageComponent } from "src/app/register/screens/register-page/register-page.component";

const routes: Routes = [
  { path: "", redirectTo: "dashboard", pathMatch: "full" },
  {
    path: "dashboard",
    loadChildren: async () =>
      (await import("./dashboard/dashboard.routes")).dashboardRoutes,
  },
  {
    path: "alerts",
    loadChildren: async () =>
      (await import("./alert/alert.routes")).alertRoutes,
  },
  {
    path: "places",
    loadChildren: async () =>
      (await import("./place/place.routes")).placeRoutes,
  },
  {
    path: "showerheads",
    loadChildren: async () =>
      (await import("./showerheads/showerheads.routes")).showerheadsRoutes,
  },
  {
    path: "meters",
    loadChildren: async () =>
      (await import("./meter/meter.routes")).meterRoutes,
  },
  {
    path: "gateways",
    loadChildren: async () =>
      (await import("./gateway/gateway.routes")).gatewayRoutes,
  },
  {
    path: "accounts",
    loadChildren: async () =>
      (await import("./child-account/child-account.routes")).childAccountRoutes,
  },
  {
    path: "settings",
    loadChildren: async () =>
      (await import("./settings/settings.routes")).settingsRoutes,
  },
  {
    path: "login",
    loadComponent: async () =>
      (await import("./login/screens/login-page/login-page.component"))
        .LoginPageComponent,
  },
  {
    path: "forgot-password",
    loadComponent: async () =>
      (
        await import(
          "./login/screens/forgot-password/forgot-password.component"
        )
      ).ForgotPasswordComponent,
  },
  {
    path: "forgot-password-conf/:emailBase64",
    loadComponent: async () =>
      (
        await import(
          "./login/screens/forgot-password-confirmation/forgot-password-confirmation.component"
        )
      ).ForgotPasswordConfirmationComponent,
  },
  { path: "register", component: RegisterPageComponent },
  { path: "register/:emailBase64", component: RegisterPageComponent },
  { path: "register-conf", component: RegisterConfirmationComponent },
  { path: "verify-account", component: ConfirmAccountComponent },
  {
    path: "onboarding",
    loadComponent: async () =>
      (await import("./onboarding/screens/onboarding/onboarding.component"))
        .OnboardingComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "onboarding/timezone",
    loadComponent: async () =>
      (
        await import(
          "./onboarding/screens/timezone-first-select/timezone-first-select.component"
        )
      ).TimezoneFirstSelectComponent,
    canActivate: [AuthGuard],
  },
  {
    path: "maintenance",
    loadComponent: async () =>
      (
        await import(
          "./login/screens/maintenance-mode/maintenance-mode.component"
        )
      ).MaintenanceModeComponent,
  },
  { path: "maintenance", component: MaintenanceModeComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor(router: Router, prelaunchService: PrelaunchService) {
    prelaunchService.check().subscribe((prelaunch: Prelaunch) => {
      if (prelaunch.maintenance) {
        router.navigate(["maintenance"], { replaceUrl: true });
      }
    });
  }
}
